/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumMessageChannel = "chat" | "email" | "fax" | "inapp" | "sms" | "voice" | "whatsapp" | "%future added value";
export type EnumMessageNotifyToChannel = "chat" | "email" | "fax" | "inapp" | "sms" | "voice" | "whatsapp" | "%future added value";
export type EnumMessageRef = "appointmentOffer" | "botFollowup" | "broadcast" | "chat" | "chatAudit" | "chatAuditTz" | "chatNotification" | "feedback" | "feedbackReminder" | "followup" | "formReminder" | "generic" | "outboundReferralOutreach" | "outboundReferralReminder" | "pinVerification" | "referralFollowup" | "referralRedirect" | "referralReminder" | "reminder" | "reschedule" | "stop" | "telehealth" | "waitingRoomPatient" | "waitlist" | "waitlistOffer" | "%future added value";
export type EnumMessageStatus = "delivered" | "opened" | "pending" | "sent" | "skipped" | "undelivered" | "%future added value";
export type EnumMessageType = "inbound" | "outbound" | "%future added value";
export type EnumMessageVisibility = "internal" | "private" | "public" | "%future added value";
export type TypographyMessageDetails_EmbedMessage = {
    readonly channel: EnumMessageChannel | null;
    readonly createdAt: unknown | null;
    readonly ref: EnumMessageRef | null;
    readonly secure: boolean | null;
    readonly type: EnumMessageType | null;
    readonly visibility: EnumMessageVisibility | null;
    readonly to: string | null;
    readonly facility: {
        readonly _id: string;
        readonly name: string | null;
    } | null;
    readonly media: {
        readonly url: string | null;
    } | null;
    readonly retry: {
        readonly count: number | null;
    } | null;
    readonly notifyTo: ReadonlyArray<{
        readonly channel: EnumMessageNotifyToChannel | null;
        readonly to: string | null;
    } | null> | null;
    readonly status: EnumMessageStatus | null;
    readonly externalStatus: {
        readonly reason: string | null;
    } | null;
    readonly " $refType": "TypographyMessageDetails_EmbedMessage";
};
export type TypographyMessageDetails_EmbedMessage$data = TypographyMessageDetails_EmbedMessage;
export type TypographyMessageDetails_EmbedMessage$key = {
    readonly " $data"?: TypographyMessageDetails_EmbedMessage$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TypographyMessageDetails_EmbedMessage">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channel",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "to",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TypographyMessageDetails_EmbedMessage",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ref",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secure",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Facility",
      "kind": "LinkedField",
      "name": "facility",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "_id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageMedia",
      "kind": "LinkedField",
      "name": "media",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageRetry",
      "kind": "LinkedField",
      "name": "retry",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageNotifyTo",
      "kind": "LinkedField",
      "name": "notifyTo",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageExternalStatus",
      "kind": "LinkedField",
      "name": "externalStatus",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reason",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Message",
  "abstractKey": null
};
})();
(node as any).hash = '911ab7082c644e7223e9800e3900162a';
export default node;
